import defaultAttributes from '../defaultAttributes';

const FlagTriangleRight = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M7 22V2l10 5-10 5' }]],
];

export default FlagTriangleRight;
